export const HASH = {
    openMysteryBoxHistory: 'openMysteryBoxHistory',
};
